import React, { useEffect, useState, useCallback } from 'react';
import { GET_DRIVER_LIST, BASE_API_URI } from '../constant';
import axios from 'axios';
import DriverTable, { mapDriverApiToTableRow } from '../components/tables/DriverTable';
import { currentDateFormat } from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import SearchComponent from '../components/SearchComponent';

const DRIVERS_LIST_URL = `${BASE_API_URI}/drivers`;
const DEFAULT_PAGE_LIMIT = 10;

const DriverList = () => {
  const [driverDetails, setDriverDetails] = useState([]);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [driverList, setDriverList] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  /** API status filter: 1 = Active (default), 0 = Inactive */
  const [statusFilter, setStatusFilter] = useState('1');
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    recordsPerPage: DEFAULT_PAGE_LIMIT,
  });

  const loadDriverAutocomplete = async () => {
    const response = await axios.get(GET_DRIVER_LIST);
    setDriverList(response.data);
  };

  const fetchDrivers = useCallback(async (page = 1, options = {}) => {
    const status = options.status ?? statusFilter;
    const driverId =
      options.driverId !== undefined
        ? options.driverId
        : selectedDriver?.value?.user_id || '';
    const limit = pagination.recordsPerPage || DEFAULT_PAGE_LIMIT;

    dispatch(setLoading(true));
    try {
      const response = await axios.get(DRIVERS_LIST_URL, {
        params: {
          page,
          limit,
          driverId: driverId || '',
          status,
        },
      });

      const isOk =
        response?.data?.success === true ||
        response?.data?.code === 200 ||
        response?.status === 200;

      if (isOk) {
        const rawList = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];
        setDriverDetails(rawList.map(mapDriverApiToTableRow));

        const p = response?.data?.pagination || {};
        setPagination({
          currentPage: p.currentPage ?? page,
          totalPages: Math.max(1, p.totalPages ?? 1),
          totalRecords: p.totalRecords ?? rawList.length,
          recordsPerPage: p.recordsPerPage ?? limit,
        });
      } else {
        setDriverDetails([]);
        setPagination((prev) => ({
          ...prev,
          currentPage: page,
          totalPages: 1,
          totalRecords: 0,
        }));
      }
    } catch (error) {
      console.error(error);
      setDriverDetails([]);
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch, pagination.recordsPerPage, selectedDriver, statusFilter]);

  useEffect(() => {
    loadDriverAutocomplete();
    fetchDrivers(1, { status: '1', driverId: '' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = async () => {
    setIsSearchLoading(true);
    const driverId = selectedDriver?.value?.user_id || '';
    try {
      await fetchDrivers(1, { driverId, status: statusFilter });
    } finally {
      setIsSearchLoading(false);
    }
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    const driverId = selectedDriver?.value?.user_id || '';
    fetchDrivers(1, { status: value, driverId });
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > pagination.totalPages) return;
    fetchDrivers(page);
  };

  const driverListWithFullName = driverList.map(driver => {
    const fullName = `${driver.first_name || ''} ${driver.middle_name || ''} ${driver.last_name || ''}`
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    return {
      ...driver,
      full_name: fullName
    };
  });

  const { currentPage: pg, totalPages, totalRecords, recordsPerPage } = pagination;
  const startIndex = (pg - 1) * recordsPerPage;

  const getPageNumbers = () => {
    if (totalPages <= 4) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    return [1, 2, 3, 'ellipsis', totalPages];
  };

  return (
    <>
      <div>
        <section>

          <div className='d-flex justify-content-between form-container'>
            <div>
              <h2 className="fs-5 font-weight-600">Driver List  </h2>
            </div>
            <div>
              <span >{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <section className='filter-section'>
          <div className='d-flex justify-content-between filter-container' style={{ background: 'rgb(205 228 218 / 29%)' }}>

            <div className='schedule-filter'>

              <div className="me-2">
                <SearchComponent
                  data={driverListWithFullName}
                  searchFields={["full_name"]}
                  placeholder="Search Driver"
                  label="Driver"
                  onSelect={(selectedDriver) => {
                    setSelectedDriver(selectedDriver);
                  }}
                  onChange={(selectedDriver) => {
                    setSelectedDriver(selectedDriver);
                  }}
                />
              </div>

              <div className="me-2">
                <label style={{ display: 'block' }}>Status</label>
                <select
                  className="form-select"
                  value={statusFilter}
                  onChange={handleStatusChange}
                  style={{ height: '38px', minWidth: '120px' }}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>

              <div>
                <div>
                <button
                  className="btn btn-primary rounded-1"
                  type="button"
                  style={{
                    background: "#31876f",
                    border: "unset",
                    height: "38px",
                    color: "#fff",
                    padding: "7px",
                  }}
                  onClick={handleSearch}
                  disabled={isSearchLoading}
                >
                  {isSearchLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Searching...
                    </>
                  ) : (
                    "Search"
                  )}
                </button>
                </div>
              </div>

            </div>


          </div>
        </section>
        <section>
          <div>
            <DriverTable tableData={driverDetails} startIndex={startIndex} />
          </div>
          {totalPages > 1 && (
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3 px-1">
              <div className="text-muted small">
                Showing {totalRecords === 0 ? 0 : startIndex + 1}–
                {Math.min(startIndex + driverDetails.length, totalRecords)} of{' '}
                {totalRecords} results
              </div>
              <div className="d-flex align-items-center gap-1">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  disabled={pg === 1}
                  onClick={() => handlePageChange(1)}
                >
                  First
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  disabled={pg === 1}
                  onClick={() => handlePageChange(pg - 1)}
                >
                  Prev
                </button>
                {getPageNumbers().map((item, idx) =>
                  item === 'ellipsis' ? (
                    <span key={`ellipsis-${idx}`} className="px-1">
                      …
                    </span>
                  ) : (
                    <button
                      key={item}
                      type="button"
                      className={`btn btn-sm ${pg === item ? 'btn-primary' : 'btn-outline-secondary'}`}
                      style={
                        pg === item
                          ? { background: '#31876f', borderColor: '#31876f' }
                          : undefined
                      }
                      onClick={() => handlePageChange(item)}
                    >
                      {item}
                    </button>
                  ),
                )}
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  disabled={pg === totalPages}
                  onClick={() => handlePageChange(pg + 1)}
                >
                  Next
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  disabled={pg === totalPages}
                  onClick={() => handlePageChange(totalPages)}
                >
                  Last
                </button>
              </div>
            </div>
          )}
        </section>
        {loading && <Loader />}
      </div>
    </>
  );
}
export default DriverList;
